var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedeem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 7.475,
    x2: 55.432,
    y1: 15.782,
    y2: 15.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#010000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#010000",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    y1: 47.099,
    y2: 47.099
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    y1: 53.881,
    y2: 53.881
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M20.921 15.404h.267v11.158c0 1.654 1.346 3 3 3h15.624c1.654 0 3-1.346 3-3V15.404c1.743.128 3.276-1.237 3.268-3V10.72a3.008 3.008 0 0 0-3.099-3V5.002a2.997 2.997 0 0 0-1.573-2.639 2.989 2.989 0 0 0-3.068.129l-3.167 2.071c-.587-1.164-1.781-1.972-3.172-1.972s-2.585.808-3.172 1.972l-3.166-2.071c-.922-.604-2.098-.653-3.069-.129S21.02 3.898 21.02 5.002V7.72a3.008 3.008 0 0 0-3.099 3v1.684c0 1.654 1.346 3 3 3zm2.267 11.158V15.404h5.248v12.158h-4.248c-.551 0-1-.448-1-1zm7.248 1V15.404h3.129v12.158zm0-17.842h3.129v3.684h-3.129zm10.376 16.842a1 1 0 0 1-1 1h-4.247V15.404h5.247zM44.08 10.72v1.684a1 1 0 0 1-1 1h-7.515V9.72h7.515a1 1 0 0 1 1 1zm-4.646-6.554a.972.972 0 0 1 1.022-.044.982.982 0 0 1 .524.88V7.72h-5.416V6.697l3.869-2.53zM32 4.591c.863 0 1.564.702 1.564 1.564v1.564h-3.129V6.155c0-.862.702-1.564 1.564-1.564zm-8.98.411c0-.538.367-.794.524-.88a.977.977 0 0 1 1.023.044l3.868 2.53v1.023h-5.416V5.001zm-3.099 5.718c0-.552.449-1 1-1h7.515v3.684h-7.515c-.551 0-1-.448-1-1z",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M52.228 32.198H11.772c-1.654 0-3 1.346-3 3V59c0 1.654 1.346 3 3 3h40.456c1.654 0 3-1.346 3-3V35.198c0-1.654-1.346-3-3-3zm-40.455 2h40.455a1 1 0 0 1 1 1v1.732H10.772v-1.732c0-.552.449-1 1-1zm41.455 10.139H10.772v-5.406h42.456zm-1 15.663H11.772c-.551 0-1-.448-1-1V46.337h42.456V59a1 1 0 0 1-1 1z",
    opacity: 1,
    "data-original": "url(#b)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M25.495 49.742h-7.168c-1.654 0-3 1.346-3 3v2.277c0 1.654 1.346 3 3 3h7.168c1.654 0 3-1.346 3-3v-2.277c0-1.654-1.346-3-3-3zm1 5.277c0 .552-.449 1-1 1h-7.168c-.551 0-1-.448-1-1v-2.277c0-.552.449-1 1-1h7.168c.551 0 1 .448 1 1z",
    opacity: 1,
    "data-original": "url(#c)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeem);
export default __webpack_public_path__ + "static/media/redeem.2c294ddcd981ed33971d4ae1bce63e61.svg";
export { ForwardRef as ReactComponent };